module.exports = __webpack_public_path__ + "img/apple-store.8c9f3511.png";